type SessionTokenGetter = () => Promise<string | null>;

let sessionTokenGetter: SessionTokenGetter | null = null;

/** Registered by the active auth provider (Clerk) for axios interceptors. */
export function registerSessionTokenGetter(getter: SessionTokenGetter | null): void {
  sessionTokenGetter = getter;
}

export async function getSessionBearerToken(): Promise<string | null> {
  if (!sessionTokenGetter) {
    return null;
  }
  try {
    return await sessionTokenGetter();
  } catch {
    return null;
  }
}
